/**
 * @module heroImages
 * @description Ordered list of hero carousel image filenames.
 * Images are served from public/media/hero/ and rotate every 4 seconds in the Hero component.
 */
const heroImages = [
  'Gletschertrekking-Winter-Saas-Fee-2022-0009.webp',
  'House.webp',
  'IMG_5776.webp',
  'Saas-Fee-Dorf-Winter-2024 (2).webp',
];

export default heroImages;
